export default {
	namespaced: true,
	state: {
		endpoint: '/document/member',
		name: 'DocumentMember',
		title: {
			single: 'DocumentMember',
			plural: 'DocumentMembers'
		},
		icon: 'mdi-account-tie-hat',
		items: [],
		headers: [
			{ text: 'ID', value: 'id', sortable: true, width: '50' },
			{ text: 'Код', value: 'code', sortable: true },
			{ text: 'Назва', value: 'name', sortable: true },
			{ text: 'type', value: 'type.name', sortable: true},
			{ text: 'Опис', value: 'description', sortable: true },
			{ text: 'actions', value: 'actions', sortable: false, width: '10%' },
		],
		item: {
			type: {},
			member: {},
			user: {},
		},
	},
	actions: {
		clearItem(context) {
			context.commit('item', {
				type: {},
				member: {},
				user: {},
			})
		},
	},
}
